import { BaseEntity } from './base-entity';
import { ParentEntity } from './parent-entity';
import { Currency } from './currency';
import { PrimaryFunction } from './primary-function';
import { Country } from './country';
import { Container } from './container';
import { CurrencyConversion } from './currency-conversion';
import { Collapsible } from '../interfaces';
import { LegalEntityLocation } from './legal-entity-location';

export class Entity extends BaseEntity implements Collapsible {
  name: string;
  code: string;
  fiscalYearEnd: string;
  description: string;
  upe: boolean;
  upeCurrency: Currency = new Currency();
  upeCurrencyScale: number;
  upeName: string;
  primaryFunction: PrimaryFunction = new PrimaryFunction();
  domicile: Country = new Country();
  taxJurisdiction: Country = new Country();
  parentEntities: ParentEntity[];
  container: Container = new Container();
  collapsed?: boolean;
  legalEntityCurrencyConversion: CurrencyConversion[];
  legalEntityLocations?: LegalEntityLocation[];
  label?: string;
  otherPrimaryFunction?: string;
  isSelectedAsSource?: boolean;
  isSelectedAsDestination?: boolean;
}
